<script lang="ts">import { cfgToThemeCdnPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
export let title;
export let description;
export let icon;
export let isLast = false;
$: iconSrc = cfgToThemeCdnPath(`/about-vip/${icon}.png`);
</script>

<div class="earn-card" class:earn-card-last={isLast}>
	<div class="earn-card-text">
		<h3 class="earn-card-title">{title}</h3>
		<p class="earn-card-description">{description}</p>
	</div>
	<div class="earn-card-icon">
		<img src={iconSrc} alt={$t(Verbiage.vip_icons_alt, 'alts')} />
	</div>
</div>

<style>
	.earn-card {
		display: flex;
		width: 100%;
		align-items: flex-start;
		justify-content: space-between;
		gap: 1rem;
		padding-top: 1rem;
		padding-bottom: 1rem;
		border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
	.earn-card-last {
		border-bottom: none;
		padding-bottom: 0;
	}
	.earn-card-text {
		display: flex;
		flex-direction: column;
		gap: 0.5rem;
}
	.earn-card-title {
		font-size: 1.25rem;
		line-height: 1.75rem;
		font-weight: 700;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
	.earn-card-description {
		font-size: 0.875rem;
		line-height: 1.25rem;
		--tw-text-opacity: 1;
		color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
	.earn-card-icon {
		flex-shrink: 0;
}
	.earn-card-icon img {
		width: auto;
		-o-object-fit: contain;
		   object-fit: contain;
		height: 56px;
}

	@media (min-width: 1024px) {
		.earn-card {
			border-bottom: none;
			padding-top: 0px;
			padding-bottom: 0px;
		}
		.earn-card-icon img {
			height: 88px;
		}
	}
</style>
